/* src/app/forbidden/forbidden.component.scss */
/*# sourceMappingURL=forbidden.component.css.map */
